const classPrefix = 'faq'
const dataPrefix = 'data-faq'

document.querySelectorAll(`[${dataPrefix}]`).forEach(($container) => {
    faq($container);
});
export function faq($container) {
    const wrapperAttr = 'data-faq-wrapper';
    const contentAttr = 'data-faq-wrap';

    const headers = $container.querySelectorAll(`[${wrapperAttr}]`);

    headers.forEach(header => {
        header.addEventListener('click', () => {
            const id = header.getAttribute(wrapperAttr);
            const content = $container.querySelector(`[${contentAttr}="${id}"]`);

            if (!content) return;

            const isOpen = content.classList.contains('is-open');

            header.classList.remove('is-open')
            // Закрываем все
            $container.querySelectorAll(`[${contentAttr}]`).forEach(el => {
                el.classList.remove('is-open');
                el.style.maxHeight = null;
            });

            // Открываем, если был закрыт
            if (!isOpen) {
                content.classList.add('is-open');
                header.classList.add('is-open')
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}
